import React from "react";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

class Page404 extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container + " fullWidth"}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={11}>
            <Card testimonial>
              <div >
                <h1>Page 405</h1>
              </div>
              <CardBody>
                Have not this path.
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(Page404);
